import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, TextField, FormHelperText } from '@mui/material';
import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { BookConsultancyModalProps } from '../../../interfaces/Credits';

const BookConsultancyModal: React.FC<BookConsultancyModalProps> = ({ open, onClose, handleBookConsultancy, credits, pinner_pro, project_name }) => {
    const { t } = useTranslation();
    const [message, setMessage] = useState<string>('');
    const [step, setStep] = useState<number>(0);
    const [error, setError] = useState<string>('');

    const handleNextStep = () => {
        if (!message.trim()) {
            setError(t('consultancy:message_required'));
            return;
        }
        setError('');
        setStep(step + 1);
    };

    const handleSubmit = () => {
        handleBookConsultancy(message);
        setStep(0);
        onClose();
    };

    const handleClose = () => {
        setMessage('');
        setError('');
        setStep(0);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {step === 0 ? (
                    <Typography variant="h6" align="left">{t('consultancy:modal_book_title')}</Typography>
                ) : (
                    <Typography variant="h6" align="left">{t('consultancy:modal_book_title_2')}</Typography>
                )}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {step === 0 ? (
                    <>
                        <TextField
                            multiline
                            rows={4}
                            fullWidth
                            variant="outlined"
                            required
                            error={!!error}
                            placeholder={t('consultancy:modal_message_placeholder')}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            sx={{
                                margin: 0,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#E0E0E0',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#E0E0E0',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#E0E0E0',
                                    },
                                },
                                '& .MuiInputLabel-root': {
                                    color: '#000000',
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#000000',
                                },
                                '& .MuiInputBase-input.Mui-disabled': {
                                    color: '#000000',
                                },
                                '& .MuiFormHelperText-root': {
                                    textAlign: 'right',
                                    marginRight: '5px',
                                }
                            }}
                        />
                        {error && (
                            <FormHelperText error>
                                {error}
                            </FormHelperText>
                        )}
                    </>
                ) : (
                    <>
                        {project_name === "" ? (
                            <Typography variant="body1" align="left">{t('consultancy:modal_book_body_1')}<span style={{ fontWeight: 'bold' }}>{credits}</span>{t('consultancy:modal_book_body_2')}<span style={{ fontWeight: 'bold' }}>{pinner_pro}</span>.{t('consultancy:modal_book_body_3')}</Typography>
                        ) : (
                            <Typography variant="body1" align="left">{t('consultancy:modal_book_body_1')}<span style={{ fontWeight: 'bold' }}>{credits}</span>{t('consultancy:modal_book_body_2')}<span style={{ fontWeight: 'bold' }}>{project_name}</span>.{t('consultancy:modal_book_body_3')}</Typography>
                        )}

                    </>
                )}
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 2, px: 3 }}>
                {step === 0 ? (
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{
                            backgroundColor: '#E9495A',
                            color: '#fff',
                            '&:hover': { backgroundColor: "#E6263B" }
                        }}
                        onClick={handleNextStep}
                    >
                        {t('common:next')}
                    </Button>
                ) : (
                    <>
                        <Button
                            fullWidth
                            variant="outlined"
                            sx={{
                                backgroundColor: 'trasparent', color: '#475467', border: '1px solid #667085'
                            }}
                            onClick={handleClose}
                        >
                            {t('common:cancel')}
                        </Button>

                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                backgroundColor: '#E9495A',
                                color: '#fff',
                                '&:hover': { backgroundColor: "#E6263B" }
                            }}
                            onClick={handleSubmit}
                        >
                            {t('common:confirm')}
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default BookConsultancyModal;